module.exports = __webpack_public_path__ + "img/foto-illy-negozio-incantalia.39ab3983.jpg";